"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarkdownComponent = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var utils_1 = require("../../../utils");
var MarkdownComponent = /** @class */ (function (_super) {
    tslib_1.__extends(MarkdownComponent, _super);
    function MarkdownComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MarkdownComponent.prototype.render = function () {
        var maybeRenderedHtml = this.props.value.renderedHtml;
        return (React.createElement("div", { className: 'component markdown-component', "data-component-type": 'markdown' },
            React.createElement(utils_1.RenderHtml, { html: maybeRenderedHtml, className: 'rendered-html' })));
    };
    return MarkdownComponent;
}(React.PureComponent));
exports.MarkdownComponent = MarkdownComponent;
//# sourceMappingURL=markdown-component.comp.js.map